export default __webpack_public_path__ + "static/media/7.043e48cb.jpg";